export default __webpack_public_path__ + "static/media/img_01.0582dae7.jpg";